import React, { useEffect, useState } from "react";
import type { Variants } from "framer-motion";
import { motion } from "framer-motion";
import { AlertTriangle, Home, ArrowRight } from "lucide-react"; // Changed Rocket to Construction
import { FleetrifyButton } from "../../components/Button/customButton";
import { useNavigate } from "react-router";
import { FLEETRIFYROUTEPATH } from "../../routes/routesPath";

const NotFoundPage = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };
  

  // Construction icon animation - more fitting for a 404
  // const constructionVariants = {
  //   initial: { opacity: 0, scale: 0.5 },
  //   animate: {
  //     opacity: 1,
  //     scale: 1,
  //     rotate: [0, 10, 0, -10, 0], // Subtle rotation
  //     transition: {
  //       duration: 2,
  //       ease: "easeInOut",
  //       repeat: Infinity,
  //     },
  //   },
  // };

  const constructionVariants: Variants = {
    initial: { opacity: 0, scale: 0.5 },
    animate: {
      opacity: 1,
      scale: 1,
      rotate: [0, 10, 0, -10, 0],
      transition: {
        duration: 2,
        ease: "easeInOut" as const,
        repeat: Infinity,
      },
    },
  };

  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col items-center justify-center p-4">
      {isMounted && (
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="text-center space-y-8"
        >
          {/* Construction Icon Animation */}
          <motion.div variants={itemVariants} className="flex justify-center">
            <motion.svg
              variants={constructionVariants}
              initial="initial"
              animate="animate"
              width="80"
              height="80"
              viewBox="0 0 64 64" // Example viewBox, adjust as needed for your icon
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-yellow-400" // Added color to the icon
            >
              <path
                d="M9.625 22H11.5625V42H9.625V22ZM29.875 14H34.125V50H29.875V14ZM52.4375 22H54.375V42H52.4375V22Z"
                fill="currentColor"
              />
              <path
                d="M57.3125 2H62V7H57.3125V2ZM2.0625 2H6.75 7H2.0625V2ZM32 2H36.6875V11H32V2Z"
                fill="currentColor"
              />
            </motion.svg>
          </motion.div>

          {/* 404 Message */}
          <motion.h1
            variants={itemVariants}
            className="text-4xl sm:text-6xl md:text-7xl font-extrabold text-white tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-orange-500" // Changed gradient
          >
            404
          </motion.h1>
          <motion.p
            variants={itemVariants}
            className="text-lg sm:text-xl text-gray-300 max-w-xl mx-auto"
          >
            Uh oh! Looks like something is broken. This page is under
            construction.
          </motion.p>

          {/* Action Buttons */}
          <motion.div
            variants={itemVariants}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <FleetrifyButton
              onClick={() => navigate(FLEETRIFYROUTEPATH.DASHBOARD)}
              className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white px-6 py-3 rounded-full shadow-lg transition-all duration-300 flex items-center gap-2"
            >
              <Home className="w-5 h-5" />
              Take Me Home
            </FleetrifyButton>
            <FleetrifyButton
              // change to your contact page
              className="bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-gray-900 px-6 py-3 rounded-full shadow-lg transition-all duration-300 flex items-center gap-2" // Changed button color to fit construction theme
            >
              Contact Support
              <ArrowRight className="w-5 h-5 text-gray-900" />
            </FleetrifyButton>
          </motion.div>

          {/* Subtle Alert Icon */}
          <motion.div variants={itemVariants} className="mt-12">
            <AlertTriangle className="w-12 h-12 text-yellow-400 mx-auto animate-pulse" />{" "}
            {/* Changed color to yellow */}
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default NotFoundPage;
